import ko from "knockout";
import "flow/bindings/clickBinding";
import myFlowLocator from "flow/utils/myFlowLocator";
import register from "flow/knockout/register";

register.registerKnockoutBinding("clickWithConfirmation", {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const newValueAccessor = function () {
            return function () {
                const myFlow = myFlowLocator.getMyFlow(bindingContext.$root);

                const param = valueAccessor();

                const config = {
                    action: param,
                    confirmationTitle: myFlow.translate("FlowHtml.Translations.Cancel"),
                    confirmationText: myFlow.translate("FlowHtml.Translations.CancelConfirmation")
                };

                // If overriding defaults with a configuration object
                if (typeof param !== "function") {
                    config.action = param.action;

                    if (param.confirmationTitle) {
                        config.confirmationTitle = ko.utils.unwrapObservable(param.confirmationTitle);
                    }

                    if (param.confirmationText) {
                        config.confirmationText = ko.utils.unwrapObservable(param.confirmationText);
                    }
                }

                myFlow
                    .showConfirmDialog(
                        config.confirmationTitle,
                        config.confirmationText,
                        myFlow.translate("FlowHtml.Translations.Yes"),
                        myFlow.translate("FlowHtml.Translations.No")
                    )
                    .done(function (result) {
                        if (result === true) {
                            const vm = bindingContext.$data;
                            config.action.apply(vm);
                        }
                    });
            };
        };

        return ko.bindingHandlers.click.init(element, newValueAccessor, allBindingsAccessor, viewModel, bindingContext);
    }
});
